import tw from 'tailwind-styled-components'
import {AvatarSize} from '@components/common/base/avatar/types'
import {getSize} from '@components/common/base/avatar/utils'

export const TwAvatarContainer = tw.div`
  -ml-8
`

export const TwAvatar = tw.div<{$size: AvatarSize}>`
  ${({$size}) => getSize($size)}
  border-radius
  select-none
  rounded-full
  bg-center
  bg-no-repeat
  bg-cover
  border-1
  border-solid
  text-[10px]
`
